"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Relation = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

var _helpers = require("../../util/helpers");

var _Avatar = require("../Avatar");

require("./Relation.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}; // Relation


var Relation = function Relation(_ref) {
  var baseURL = _ref.baseURL,
      relation = _ref.relation;
  var fullName = relation ? relation.user.first_name + ' ' + relation.user.last_name + ' ' : '-';
  var initials = relation ? (0, _helpers.getInitials)(relation.user.first_name, relation.user.last_name) : '-';
  var relationString = relation ? relation.relation === 'self' ? 'me' : relation.relation : '-';

  if (relationString === 'spouse') {
    relationString = 'family';
  }

  var relationship = relation ? "(".concat(capitalizeFirstLetter(relationString), ")") : '';
  var relationLink = relation ? "".concat(baseURL, "/find/user/").concat(relation.user_id) : '';
  var relationImageUrl = relation ? relation.user.image_url : '';
  var email = relation ? relation.user.email : '';
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    tag: "a",
    href: relationLink,
    className: "RelationListRelation",
    trkAction: "Family Member Link Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    marginBottom: "4",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_Avatar.Avatar, {
    imageUrl: relationImageUrl,
    initials: initials
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    alignItems: "flex-start",
    justifyContent: "center",
    marginLeft: "3"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "relation-name",
    type: _atoms.Label.Type.Body,
    color: _atoms.Color.Trace
  }, fullName, " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "relation"
  }, relationship)), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "email",
    type: _atoms.Label.Type.SmallBody,
    color: _atoms.Color.Grey1
  }, email))));
};

exports.Relation = Relation;